import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";

import ClientForm, { ClientFormInput } from "../../components/ClientForm";
import useRequireCurrentClient from "../../hooks/useRequireCurrentClient";
import useClientUpdate from "./api/useClientUpdate";

export default function ClientUpdateScreen() {
    const { t } = useTranslation("client");
    const navigate = useNavigate();

    const { client } = useRequireCurrentClient();
    const { updateClient, error } = useClientUpdate(client.id);

    const initialData: ClientFormInput = useMemo(
        () => ({
            name: client.name,
            type: client.type,
            address: client.address,
            contactName: client.contactName,
            contactEmail: client.contactEmail,
            contactPhone: client.contactPhone,
            website: client.website ?? null,
            profilePicture: null,
            isAllMapEditorLayersDefaultVisible: client.isAllMapEditorLayersDefaultVisible,
        }),
        [client],
    );

    const handleSubmit = async (data: ClientFormInput) => {
        await updateClient({
            ...data,
            contactEmail: data.contactEmail || null,
            website: data.website ?? null,
            profilePicture: data.profilePicture ?? null,
        });
        navigate(-1);
    };

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={client.name}>
                <ClientForm
                    initialData={initialData}
                    onSubmit={handleSubmit}
                    error={error}
                    formButtonLabel={t("clientUpdateScreen.btnSubmit")}
                />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
